import { createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "center-wrapper"
}
const _hoisted_2 = { class: "center-wrapper" }
const _hoisted_3 = { class: "input-inline" }
const _hoisted_4 = { class: "input-inline" }
const _hoisted_5 = { class: "input-inline" }
const _hoisted_6 = { class: "input-inline" }
const _hoisted_7 = { class: "input-inline" }
const _hoisted_8 = { class: "input-inline" }
const _hoisted_9 = { class: "input-inline" }
const _hoisted_10 = { class: "inline-or-block" }
const _hoisted_11 = { style: {"padding-left":"10px"} }
const _hoisted_12 = { class: "button-sets" }
const _hoisted_13 = { class: "button-sets" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = { class: "button-sets" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = ["disabled"]
const _hoisted_18 = { class: "button-sets" }
const _hoisted_19 = { class: "button-sets" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = { style: {"padding-left":"10px"} }
const _hoisted_22 = { class: "table-header" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = ["onUpdate:modelValue", "onChange"]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = ["onClick"]
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { style: {"word-break":"break-all"} }
const _hoisted_29 = { style: {"word-break":"break-all"} }
const _hoisted_30 = { style: {"line-break":"anywhere"} }
const _hoisted_31 = { style: {"word-break":"break-all","min-width":"30px"} }
const _hoisted_32 = { style: {"line-break":"anywhere"} }
const _hoisted_33 = { style: {"word-break":"break-all"} }
const _hoisted_34 = ["onUpdate:modelValue", "onChange"]
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { style: {"line-break":"anywhere"} }
const _hoisted_37 = { style: {"line-break":"anywhere"} }
const _hoisted_38 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_JapaneseInput = _resolveComponent("JapaneseInput")!
  const _component_select_prefecture = _resolveComponent("select-prefecture")!
  const _component_select_store = _resolveComponent("select-store")!
  const _component_JapaneseInput_xs = _resolveComponent("JapaneseInput-xs")!
  const _component_loading = _resolveComponent("loading")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_customer_edit = _resolveComponent("customer-edit")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isSearchMode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _cache[27] || (_cache[27] = _createElementVNode("label", { class: "inline-label" }, "顧客コード", -1)),
              _withDirectives(_createElementVNode("input", {
                class: "form-control search-customer-code no-ime",
                type: "tel",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchReq.id) = $event)),
                onKeydown: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)), ["enter"])),
                onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toHankakuCode && _ctx.toHankakuCode(...args)))
              }, null, 544), [
                [_vModelText, _ctx.searchReq.id]
              ])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _cache[28] || (_cache[28] = _createElementVNode("label", { class: "inline-label" }, "顧客名", -1)),
              _createVNode(_component_JapaneseInput, {
                class: "search-customer-name",
                modelValue: _ctx.searchReq.name,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchReq.name) = $event)),
                onKeydown: _withKeys(_ctx.search, ["enter"]),
                onChange: _ctx.toHankanaWhole
              }, null, 8, ["modelValue", "onKeydown", "onChange"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _cache[29] || (_cache[29] = _createElementVNode("label", { class: "inline-label" }, "電話番号", -1)),
              _withDirectives(_createElementVNode("input", {
                class: "form-control search-customer-phoneNo no-ime",
                type: "tel",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.searchReq.phoneNo) = $event)),
                onKeydown: _cache[5] || (_cache[5] = _withKeys(
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)), ["enter"])),
                onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.toHankakuPhone && _ctx.toHankakuPhone(...args)))
              }, null, 544), [
                [_vModelText, _ctx.searchReq.phoneNo]
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _cache[30] || (_cache[30] = _createElementVNode("label", { class: "inline-label" }, "都道府県", -1)),
              _createVNode(_component_select_prefecture, {
                prefecture: _ctx.searchReq.prefecture,
                "onUpdate:prefecture": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.searchReq.prefecture) = $event)),
                onKeydown: _withKeys(_ctx.search, ["enter"])
              }, null, 8, ["prefecture", "onKeydown"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _cache[31] || (_cache[31] = _createElementVNode("label", { class: "inline-label" }, "担当店", -1)),
              _createVNode(_component_select_store, {
                store: _ctx.searchReq.store,
                "onUpdate:store": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.searchReq.store) = $event)),
                onKeydown: _withKeys(_ctx.search, ["enter"])
              }, null, 8, ["store", "onKeydown"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _cache[32] || (_cache[32] = _createElementVNode("label", { class: "inline-label" }, "備考", -1)),
              _createVNode(_component_JapaneseInput, {
                class: "search-customer-note",
                modelValue: _ctx.searchReq.note,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.searchReq.note) = $event)),
                onKeydown: _withKeys(_ctx.search, ["enter"])
              }, null, 8, ["modelValue", "onKeydown"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _cache[33] || (_cache[33] = _createElementVNode("label", {
                class: "inline-label",
                for: "hasDestCst"
              }, "送り先のない顧客は除く", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "hasDestCst",
                type: "checkbox",
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.searchReq.hasDestOnly) = $event)),
                onKeydown: _cache[11] || (_cache[11] = _withKeys(($event: any) => (_ctx.searchReq.hasDestOnly=!_ctx.searchReq.hasDestOnly), ["enter"]))
              }, null, 544), [
                [_vModelCheckbox, _ctx.searchReq.hasDestOnly]
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("button", {
                class: "btn-primary",
                onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)))
              }, "検索")
            ])
          ]),
          _cache[51] || (_cache[51] = _createElementVNode("hr", { style: {"margin":"20px 0 40px"} }, null, -1)),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("button", {
              onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.insert && _ctx.insert(...args))),
              class: "link-button"
            }, "新規追加"),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("button", {
                class: "btn-outline-primary",
                onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.outputCSV && _ctx.outputCSV(...args)))
              }, "CSV出力"),
              _createElementVNode("button", {
                class: "btn-outline-primary",
                onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.clickFileInput && _ctx.clickFileInput(...args)))
              }, "CSV登録"),
              _createElementVNode("input", {
                type: "file",
                id: "hiddenFileInput",
                onChange: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.registerCSV && _ctx.registerCSV(...args))),
                style: {"display":"none"}
              }, null, 32)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("button", {
                class: "btn-outline-primary",
                onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.remove && _ctx.remove(...args))),
                disabled: _ctx.hasNoCheck
              }, "削除", 8, _hoisted_14)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("button", {
                class: "btn-outline-primary",
                onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.printUketamawarisho && _ctx.printUketamawarisho(...args))),
                disabled: _ctx.hasNoCheck
              }, "承り書印刷", 8, _hoisted_16),
              _createElementVNode("button", {
                class: "btn-outline-primary",
                onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.printLabel && _ctx.printLabel(...args))),
                disabled: _ctx.hasNoCheck
              }, "ラベル印刷", 8, _hoisted_17)
            ]),
            _createElementVNode("div", _hoisted_18, [
              _cache[34] || (_cache[34] = _createElementVNode("label", { class: "operation-label" }, "出荷予定日", -1)),
              _withDirectives(_createElementVNode("input", {
                class: "form-control-sm",
                type: "date",
                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.shipmentDate) = $event))
              }, null, 512), [
                [_vModelText, _ctx.shipmentDate]
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _cache[35] || (_cache[35] = _createElementVNode("label", { class: "operation-label" }, "品名", -1)),
              _createVNode(_component_JapaneseInput_xs, {
                modelValue: _ctx.productName,
                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.productName) = $event))
              }, null, 8, ["modelValue"]),
              _createElementVNode("button", {
                class: "btn-outline-primary",
                disabled: _ctx.hasNoCheck,
                onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.onYamatoCSVClick && _ctx.onYamatoCSVClick(...args)))
              }, "ヤマトCSV", 8, _hoisted_20)
            ]),
            _createVNode(_component_loading, {
              ref: "buttonLoading",
              initialLoad: false,
              display: "inline-block",
              imgWidth: "26px",
              imgHeight: "26px"
            }, null, 512)
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("table", null, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", _hoisted_22, [
                  _createElementVNode("th", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.checkAll) = $event)),
                      onChange: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.onCheckAllChange && _ctx.onCheckAllChange(...args)))
                    }, null, 544), [
                      [_vModelCheckbox, _ctx.checkAll]
                    ])
                  ]),
                  _cache[36] || (_cache[36] = _createElementVNode("th", null, " ", -1)),
                  _cache[37] || (_cache[37] = _createElementVNode("th", null, [
                    _createTextVNode("顧客"),
                    _createElementVNode("br"),
                    _createTextVNode("コード")
                  ], -1)),
                  _createElementVNode("th", null, [
                    _createElementVNode("div", null, [
                      _createElementVNode("button", {
                        class: "link-button",
                        onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.orderByName()))
                      }, "顧客名"),
                      _createElementVNode("span", null, _toDisplayString(_ctx.getOrderString('name')), 1)
                    ])
                  ]),
                  _cache[38] || (_cache[38] = _createElementVNode("th", null, "顧客名カナ", -1)),
                  _cache[39] || (_cache[39] = _createElementVNode("th", null, [
                    _createTextVNode("郵便"),
                    _createElementVNode("br"),
                    _createTextVNode("番号")
                  ], -1)),
                  _cache[40] || (_cache[40] = _createElementVNode("th", null, "住所", -1)),
                  _cache[41] || (_cache[41] = _createElementVNode("th", null, "電話番号", -1)),
                  _cache[42] || (_cache[42] = _createElementVNode("th", null, "担当店", -1)),
                  _cache[43] || (_cache[43] = _createElementVNode("th", null, "備考", -1)),
                  _cache[44] || (_cache[44] = _createElementVNode("th", null, " ", -1)),
                  _cache[45] || (_cache[45] = _createElementVNode("th", null, " ", -1))
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_ctx.loading && _ctx.loading.isFirstLoadFinished && _ctx.customerTable.list.length === 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_23, [...(_cache[46] || (_cache[46] = [
                      _createElementVNode("td", {
                        colspan: "20",
                        class: "no-data"
                      }, " データがありません ", -1)
                    ]))]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customerTable.list, (customer) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: customer.id
                  }, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", null, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          "onUpdate:modelValue": ($event: any) => ((customer.check) = $event),
                          onChange: ($event: any) => (_ctx.onCustomerCheck(customer))
                        }, null, 40, _hoisted_24), [
                          [_vModelCheckbox, customer.check]
                        ])
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("button", {
                          class: "link-button edit-remove-link",
                          onClick: ($event: any) => (_ctx.edit(customer))
                        }, "編集", 8, _hoisted_25),
                        _createElementVNode("button", {
                          class: "link-button edit-remove-link",
                          onClick: ($event: any) => (_ctx.addDestination(customer))
                        }, "送り先追加", 8, _hoisted_26)
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("button", {
                          class: "link-button",
                          onClick: ($event: any) => (_ctx.switchDest(customer))
                        }, _toDisplayString(customer.id), 9, _hoisted_27)
                      ]),
                      _createElementVNode("td", _hoisted_28, _toDisplayString(customer.name), 1),
                      _createElementVNode("td", _hoisted_29, _toDisplayString(customer.kana), 1),
                      _createElementVNode("td", _hoisted_30, _toDisplayString(customer.zipCode), 1),
                      _createElementVNode("td", _hoisted_31, _toDisplayString(_ctx.$root.util.getAddress(customer)), 1),
                      _createElementVNode("td", _hoisted_32, _toDisplayString(customer.phoneNo), 1),
                      _createElementVNode("td", null, _toDisplayString(customer.storeText), 1),
                      _createElementVNode("td", _hoisted_33, _toDisplayString(_ctx.$root.util.getStartString(customer.note, 20)), 1),
                      _createElementVNode("td", null, [
                        _createVNode(_component_router_link, {
                          to: '/action?id=' + customer.id,
                          class: "link-button"
                        }, {
                          default: _withCtx(() => [...(_cache[47] || (_cache[47] = [
                            _createTextVNode("対応履歴", -1)
                          ]))]),
                          _: 1
                        }, 8, ["to"])
                      ]),
                      _createElementVNode("td", null, [
                        _createVNode(_component_router_link, {
                          to: '/order?id=' + customer.id,
                          class: "link-button"
                        }, {
                          default: _withCtx(() => [...(_cache[48] || (_cache[48] = [
                            _createTextVNode("注文履歴", -1)
                          ]))]),
                          _: 1
                        }, 8, ["to"])
                      ])
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customer.destination, (dest) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        class: _normalizeClass(["customer-destination", customer.showDestination ? 'show-tr-animation' : 'hide-tr-animation']),
                        key: dest.id
                      }, [
                        _createElementVNode("td", null, [
                          _createElementVNode("div", null, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              "onUpdate:modelValue": ($event: any) => ((dest.check) = $event),
                              onChange: ($event: any) => (_ctx.onDestCheck(customer, dest))
                            }, null, 40, _hoisted_34), [
                              [_vModelCheckbox, dest.check]
                            ])
                          ])
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", null, [
                            _createElementVNode("button", {
                              class: "link-button edit-remove-link",
                              onClick: ($event: any) => (_ctx.edit(customer, dest))
                            }, "編集", 8, _hoisted_35)
                          ])
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", null, _toDisplayString(dest.id), 1)
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", null, _toDisplayString(dest.name), 1)
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", null, _toDisplayString(dest.kana), 1)
                        ]),
                        _createElementVNode("td", _hoisted_36, [
                          _createElementVNode("div", null, _toDisplayString(dest.zipCode), 1)
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", null, _toDisplayString(_ctx.$root.util.getAddress(dest)), 1)
                        ]),
                        _createElementVNode("td", _hoisted_37, [
                          _createElementVNode("div", null, _toDisplayString(dest.phoneNo), 1)
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", null, _toDisplayString(dest.storeText), 1)
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", null, _toDisplayString(_ctx.$root.util.getStartString(dest.note, 20)), 1)
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", null, [
                            _createVNode(_component_router_link, {
                              to: '/action?id=' + dest.id,
                              class: "link-button"
                            }, {
                              default: _withCtx(() => [...(_cache[49] || (_cache[49] = [
                                _createTextVNode("対応履歴", -1)
                              ]))]),
                              _: 1
                            }, 8, ["to"])
                          ])
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", null, [
                            _createVNode(_component_router_link, {
                              to: '/order?id=' + dest.id,
                              class: "link-button"
                            }, {
                              default: _withCtx(() => [...(_cache[50] || (_cache[50] = [
                                _createTextVNode("注文履歴", -1)
                              ]))]),
                              _: 1
                            }, 8, ["to"])
                          ])
                        ])
                      ], 2))
                    }), 128))
                  ], 64))
                }), 128))
              ])
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_38, [
          _createVNode(_component_customer_edit, {
            customer: _ctx.editTarget,
            onSaveCustomer: _ctx.save
          }, null, 8, ["customer", "onSaveCustomer"]),
          _createElementVNode("button", {
            class: "link-button",
            onClick: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.back && _ctx.back(...args)))
          }, "一覧に戻る")
        ])),
    _createVNode(_component_loading, {
      minHeight: "60px",
      ref: "loading",
      enableOnScrollEnd: true,
      scrollEndMargin: 300,
      onOnscrollend: _ctx.loadNext
    }, null, 8, ["onOnscrollend"])
  ], 64))
}